import React from 'react';
import GenericError from 'src/components/GenericError/GenericError';

interface IState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<{}, IState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <GenericError />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
